import ajax from "../lib/ajax";
import authService from "./AuthService";
import { USER_TYPE_HEADER } from "../auth/userTypeUtils";

class ReportService {
  buildReportQuery(params = {}) {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        search.set(key, value);
      }
    });
    return search.toString();
  }

  async getJioPointReportTypes() {
    // const response = await ajax.get("jp/reports/types");
    // console.log("getJioPointReportType", response)
    // return response.data;
    return {
    "types": [
        {
            "id": "audit",
            "title": "Audit Report",
            "description": "User login and activity audit trail for compliance and security review.",
            "requiresSpark": false,
            "defaultRangeDays": 30,
            "maxRangeDays": 90,
            "filters": {
                "username": true
            },
            "columns": [
                {
                    "title": "User Name",
                    "dataIndex": "username"
                },
                {
                    "title": "User IP",
                    "dataIndex": "userip"
                },
                {
                    "title": "Login Time",
                    "dataIndex": "logintime"
                },
                {
                    "title": "Browser",
                    "dataIndex": "browser"
                }
            ],
            "availableFrom": "2026-04-08",
            "availableTo": "2026-07-07"
        },
        {
            "id": "gateway-state",
            "title": "Gateway State Report",
            "description": "Current gateway connection status and state snapshot from live gateway data.",
            "requiresSpark": false,
            "defaultRangeDays": 30,
            "maxRangeDays": 90,
            "filters": {
                "username": true
            },
            "columns": [
                {
                    "title": "User Name",
                    "dataIndex": "username"
                },
                {
                    "title": "Serial Number",
                    "dataIndex": "serialnumber"
                },
                {
                    "title": "JP Code",
                    "dataIndex": "jpcode"
                },
                {
                    "title": "State",
                    "dataIndex": "state"
                },
                {
                    "title": "City",
                    "dataIndex": "city"
                },
                {
                    "title": "Current State",
                    "dataIndex": "currentstate"
                },
                {
                    "title": "Latest State Time",
                    "dataIndex": "lateststatetime"
                },
                {
                    "title": "Gateway Status",
                    "dataIndex": "connectionstatus"
                }
            ],
            "availableFrom": "2026-04-08",
            "availableTo": "2026-07-07"
        },
        {
            "id": "jiopoint-state",
            "title": "Jiopoint State Report",
            "description": "Arm/disarm activity and active duration per gateway. Requires Spark Reports job.",
            "requiresSpark": true,
            "defaultRangeDays": 30,
            "maxRangeDays": 90,
            "filters": {
                "username": true
            },
            "columns": [
                {
                    "title": "User Name",
                    "dataIndex": "username"
                },
                {
                    "title": "JP Code",
                    "dataIndex": "jpcode"
                },
                {
                    "title": "State",
                    "dataIndex": "state"
                },
                {
                    "title": "City",
                    "dataIndex": "city"
                },
                {
                    "title": "Serial Number",
                    "dataIndex": "serialnumber"
                },
                {
                    "title": "Manual Disarm time",
                    "dataIndex": "msddatetime"
                },
                {
                    "title": "Manual Arm time",
                    "dataIndex": "msadatetime"
                },
                {
                    "title": "Scheduled Arm Time",
                    "dataIndex": "ssadatetime"
                },
                {
                    "title": "Active Duration",
                    "dataIndex": "activeduration"
                },
                {
                    "title": "Disarm Time(Prev)",
                    "dataIndex": "msddatetimeprev"
                },
                {
                    "title": "Arm Time(Prev)",
                    "dataIndex": "msadatetimeprev"
                },
                {
                    "title": "Active Duration(Prev)",
                    "dataIndex": "activedurationprev"
                },
                {
                    "title": "Disarm Count",
                    "dataIndex": "disarmcount"
                },
                {
                    "title": "Arm Count",
                    "dataIndex": "armcount"
                }
            ],
            "availableFrom": "2026-04-08",
            "availableTo": "2026-07-07"
        },
        {
            "id": "site-details",
            "title": "Site Details Report",
            "description": "Site-level alarm reaction metrics per gateway. Requires Spark Reports job.",
            "requiresSpark": true,
            "defaultRangeDays": 30,
            "maxRangeDays": 90,
            "filters": {
                "username": true
            },
            "columns": [
                {
                    "title": "User Name",
                    "dataIndex": "username"
                },
                {
                    "title": "Serial Number",
                    "dataIndex": "serialnumber"
                },
                {
                    "title": "JP Code",
                    "dataIndex": "jpcode"
                },
                {
                    "title": "State",
                    "dataIndex": "state"
                },
                {
                    "title": "City",
                    "dataIndex": "city"
                },
                {
                    "title": "Reacted Count",
                    "dataIndex": "reactedcount"
                },
                {
                    "title": "Unreacted Count",
                    "dataIndex": "unreactedcount"
                },
                {
                    "title": "Last Reacted Time",
                    "dataIndex": "lastreactedtime"
                },
                {
                    "title": "Last Not Reacted Time",
                    "dataIndex": "lastnotrectedtime"
                }
            ],
            "availableFrom": "2026-04-08",
            "availableTo": "2026-07-07"
        },
        {
            "id": "gateway-history",
            "title": "Gateway History Report",
            "description": "Historical gateway status and arm/disarm events. Requires Spark Report_GatewayHistory job.",
            "requiresSpark": true,
            "defaultRangeDays": 30,
            "maxRangeDays": 90,
            "filters": {
                "username": true
            },
            "columns": [
                {
                    "title": "User Name",
                    "dataIndex": "username"
                },
                {
                    "title": "Serial Number",
                    "dataIndex": "serialnumber"
                },
                {
                    "title": "JP Code",
                    "dataIndex": "jpcode"
                },
                {
                    "title": "State",
                    "dataIndex": "state"
                },
                {
                    "title": "City",
                    "dataIndex": "city"
                },
                {
                    "title": "Last Gateway Status",
                    "dataIndex": "connectionstatus"
                },
                {
                    "title": "Last Arm/Disarm State",
                    "dataIndex": "currentstate"
                },
                {
                    "title": "Last Arm/Disarm Time",
                    "dataIndex": "eventgeneration"
                }
            ],
            "availableFrom": "2026-04-08",
            "availableTo": "2026-07-07"
        },
        {
            "id": "alarm-datewise",
            "title": "Alarm Datewise Report",
            "description": "Daily alarm counts by type per gateway. Requires Spark Reports job.",
            "requiresSpark": true,
            "defaultRangeDays": 30,
            "maxRangeDays": 90,
            "filters": {
                "username": true
            },
            "columns": [
                {
                    "title": "Serial Number",
                    "dataIndex": "serialnumber"
                },
                {
                    "title": "JP Code",
                    "dataIndex": "jpcode"
                },
                {
                    "title": "State",
                    "dataIndex": "state"
                },
                {
                    "title": "City",
                    "dataIndex": "city"
                },
                {
                    "title": "Alarm",
                    "dataIndex": "floodalarm"
                },
                {
                    "title": "Gas Alarm",
                    "dataIndex": "gasalarm"
                },
                {
                    "title": "Intrusion Detected",
                    "dataIndex": "intrusiondetected"
                },
                {
                    "title": "Manual System Armed",
                    "dataIndex": "manualsystemarmed"
                },
                {
                    "title": "Manual System Disarm",
                    "dataIndex": "manualsystemdisarm"
                },
                {
                    "title": "Panic Situation",
                    "dataIndex": "panicsituation"
                },
                {
                    "title": "Scheduled System Armed",
                    "dataIndex": "scheduledsystemarmed"
                },
                {
                    "title": "Smoke Alarm",
                    "dataIndex": "smoke"
                },
                {
                    "title": "Tamper Alarm",
                    "dataIndex": "tamper"
                },
                {
                    "title": "Total Alarm",
                    "dataIndex": "allalarm"
                }
            ],
            "availableFrom": "2026-04-08",
            "availableTo": "2026-07-07"
        }
    ]
}
  }

  async getJioPointReport(type, params = {}) {
    const query = this.buildReportQuery(params);
    const response = await ajax.get(`jp/reports/${type}?${query}`);
    return response.data;
  }

  async exportJioPointReport(type, format, params = {}) {
    const query = this.buildReportQuery({ ...params, format });
    const token = await authService.getToken();
    const userType = await authService.getUserType();

    const response = await ajax.get(`jp/reports/${type}/export?${query}`, {
      responseType: "blob",
      headers: {
        ...(token ? { authorization: `Bearer ${token}` } : {}),
        ...(userType ? { [USER_TYPE_HEADER]: userType } : {}),
      },
    });

    const blob = new Blob([response.data], {
      type: format === "pdf" ? "application/pdf" : "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${type}-report.${format}`;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }

  async getAuditReport(fromDate, toDate) {
    try {
      const response = await ajax.get(
        `audit/getAuditDetailsByDate?fromDate=${fromDate}&toDate=${toDate}&userType=JH`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getAlarmDatewiseReport(selectedDate, userGroup) {
    try {
      const response = await ajax.get(
        `jhalarmNotificationJiopoint/alarmNotificationDatewise?date=${selectedDate}&userGroup=${userGroup}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getDailyStatsReport(selectedDate, userGroup) {
    try {
      const response = await ajax.get(
        `jhJslDailyReport/dailyStatsReport?date=${selectedDate}&userGroup=${userGroup}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getJSLOverallReport(selectedDate) {
    try {
      const response = await ajax.get(
        `jhJslOverallReport?date=${selectedDate}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getJSLFeedbackReport(selectedDate) {
    try {
      const response = await ajax.get(
        `jhJslFeedbacklReport?date=${selectedDate}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getSIReport() {
    try {
      const response = await ajax.get("si/reports");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getGatewayWiseReport() {
    try {
      const response = await ajax.get("si/reports/distinct-serialnumber");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getGatewayWiseSNReport(serialNumber) {
    try {
      const response = await ajax.get(
        `si/reports/search?serialNumber=${serialNumber}&siFName=&siLName=`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getGatewaysbySNReport(serialNumber) {
    try {
      const response = await ajax.get(
        `jhgateway/getGatewaysBySerialNumber?serialnumber=${serialNumber}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getSIWiseReport() {
    try {
      const response = await ajax.get("si/reports/distinct-siname");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getSearchbySNReport(fname, lname) {
    try {
      const response = await ajax.get(
        `si/reports/search?serialNumber=&siFName=${fname}&siLName=${lname}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
const reportService = new ReportService();
export default reportService;
